import { PageTitle } from "@repo/components";
import { getTranslations } from "next-intl/server";
const SearchHeader = async props => {
  const t = await getTranslations("Common");
  const {
    categoryName,
    totalCount,
    term
  } = props;
  return <div className="border-lightgray -mx-4 mb-6 flex items-center border-y px-4 py-2 md:mx-0 md:border-none md:p-0" data-sentry-component="SearchHeader" data-sentry-source-file="SearchHeader.jsx">
      {term ? <h1 className="text-3xl">{`${t("Search_Results_For")}: ${term}`}</h1> : <PageTitle title={categoryName} />}
      <div className="ms-auto">
        <p className="text-end text-sm text-[#929191] md:text-base">
          {t("Showing")}
        </p>
        <p className="text-end text-sm md:text-base">
          {totalCount} {t("Products")}
        </p>
      </div>
    </div>;
};
export default SearchHeader;